import { env } from "@/lib/env";

const AUTH_URL = `https://shopify.com/authentication/${env.NEXT_PUBLIC_SHOPIFY_SHOP_ID}`;
const CUSTOMER_ACCOUNTS_API_VERSION = "2025-01";
const STOREFRONT_API_VERSION = "2025-04";

export const SHOPIFY_CONFIG = {
  redirectUri: "/auth/callback",
  scopes: "openid email customer-account-api:full",
  codeChallengeMethod: "S256",
  responseType: "code",
  successfulLoginRedirect: env.NEXT_PUBLIC_BASE_URL,
  successfulLogoutRedirect: env.NEXT_PUBLIC_BASE_URL,
  unsuccessfulLoginRedirect: env.NEXT_PUBLIC_BASE_URL,
  unsuccessfulLogoutRedirect: env.NEXT_PUBLIC_BASE_URL,

  // Endpoints for Shopify authentication
  get authEndpoint() {
    return `${AUTH_URL}/oauth/authorize`;
  },

  // Endpoint to exchange authorization code for access token
  get tokenEndpoint() {
    return `${AUTH_URL}/oauth/token`;
  },

  // Endpoint for Shopify logout
  get logoutEndpoint() {
    return `${AUTH_URL}/logout`;
  },

  // Endpoint for customer accounts API
  get customerAccountsEndpoint() {
    return `https://shopify.com/${env.NEXT_PUBLIC_SHOPIFY_SHOP_ID}/account/customer/api/${CUSTOMER_ACCOUNTS_API_VERSION}/graphql`;
  },

  // Endpoint for customer accounts API
  get storefrontEndpoint() {
    return `https://${env.SHOPIFY_STORE_DOMAIN}/api/${STOREFRONT_API_VERSION}/graphql.json`;
  },

  // Cookie expire configurations
  COOKIE_EXPIRY_10_MINUTES_SECONDS: 10 * 60,
  COOKIE_EXPIRY_1_HOUR_SECONDS: 60 * 60,
  COOKIE_EXPIRY_1_DAY_SECONDS: 24 * 60 * 60,
  COOKIE_EXPIRY_7_DAYS_SECONDS: 7 * 24 * 60 * 60,
  COOKIE_EXPIRY_30_DAYS_SECONDS: 30 * 24 * 60 * 60,
  COOKIE_EXPIRY_1_YEAR_SECONDS: 365 * 24 * 60 * 60,
};
